/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_3_TitleInputs */

const en_vc_onl_how_3_title = /** @type {(inputs: Vc_Onl_How_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPU accelerated`)
};

const zh_vc_onl_how_3_title = /** @type {(inputs: Vc_Onl_How_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPU 加速`)
};

/**
* | output |
* | --- |
* | "GPU accelerated" |
*
* @param {Vc_Onl_How_3_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_3_title = /** @type {((inputs?: Vc_Onl_How_3_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_3_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_3_title(inputs)
	return zh_vc_onl_how_3_title(inputs)
});
export { vc_onl_how_3_title as "vc.onl.how.3.title" }